import { Injectable } from '@angular/core';

// @ts-ignore
import clone from 'clone';

@Injectable({ providedIn: 'root' })
export class ClonerService {
  deepClone<T>(value: T): T {
    return clone<T>(value);
  }
}

export function deepClone<T>(value: T): T {
  return clone<T>(value);
}
